export class Localisation {
    Label: string;
    Score: number;
    Id: string
    Name: string;
    PostCode: string;
    CityCode: string;
    X: number;
    Y: number;
    City: string;
    Context: string;
    Type: string;
    Importance: number;

    static mapFromJSON(json) {
        let loc = new Localisation();

        loc.City = json['city'];
        loc.Label = json['label'];
        loc.Id = json['id'];
        loc.Name = json['name'];
        loc.PostCode = json['postCode'];
        loc.CityCode = json['cityCode'];
        loc.X = json['x'];
        loc.Y = json['y'];
        loc.Context = json['context'];
        loc.Type = json['type'];
        loc.Importance = json['importance'];

        return loc;
    }
}